import { z } from "zod";
export const CreateEventRequestSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(1000).optional(),
});
export const UpdateEventRequestSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(1000).optional(),
}).refine(data => data.name !== undefined || data.description !== undefined, {
    message: "At least one field (name or description) must be provided for update",
});
